var _style, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapboxFovMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlnsSketch: "http://www.bohemiancoding.com/sketch/ns",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-211.2 372.9 48.2 48.2",
    style: {
      enableBackground: "new -211.2 372.9 48.2 48.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#4A4A4A;}\r\n\t.st1{opacity:0.2;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: -187.1,
    cy: 397,
    r: 8.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: -187.1,
    cy: 397,
    r: 22
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapboxFovMarker);
export default __webpack_public_path__ + "static/media/mapbox_fov_marker.2acb2950c7701267a7279754637c3a99.svg";
export { ForwardRef as ReactComponent };